import { Icon1Circle, Icon2Circle, Icon3Circle, Icon4Circle, CheckCircleFill } from "react-bootstrap-icons";

export function CheckoutIndicator( { step, success }: { step: number, success: boolean } ) {
    const steps = [<Icon1Circle />, <Icon2Circle />, <Icon3Circle />, <Icon4Circle />];
    return success ? <CheckCircleFill fill="green" /> : steps[step - 1];
}
